import { h } from 'preact'
import { useContext, useMemo, useState } from 'preact/hooks'
import { ForwardFn, forwardRef } from 'preact/compat'
import FieldsContext from 'components/business/SurveyForm/Fields/fieldsContext'

import { InlineSelect, Select } from 'components/ui'
import { CheckboxSelectField as CheckboxSelectFieldType, ChoiceStyle, SelectableFieldValue } from 'scripts/type'
import FieldWrapper from '../components/FieldWrapper'

import { FieldCommonProps } from '../type'
import { useHandlersWithRequired } from '../hooks'
import usePropValueChange from 'components/business/SurveyForm/Fields/hooks/usePropValueChange'
import cn from 'classnames'

import styles from './index.scss'

const CheckboxSelectField: ForwardFn<FieldCommonProps, HTMLDivElement> = (props, ref) => {
  const { field, required, onFieldSubmit } = props
  const [value, setValue] = useState<SelectableFieldValue>()
  const { isMultipleFields, refreshWidgetHeight } = useContext(FieldsContext)!
  const { onNext } = useHandlersWithRequired(setValue, required, onFieldSubmit)
  const { choices, choicesRandom, choicesStyle, choicesSize, rowChoiceCount, minChoices, maxChoices } = field as CheckboxSelectFieldType
  usePropValueChange(props, () => setValue(undefined))

  const disabled = useMemo(() => {
    return required && (value?.value?.length ?? 0) < (minChoices ?? 1)
  }, [required, value, minChoices])

  const handleChange = (data: SelectableFieldValue) => {
    const orderValue = choices.reduce((acc: string[], cur) => {
      acc = data?.value?.includes(cur.value) ? [...acc, cur.value] : acc
      return acc
    }, [])

    setValue({
      value: orderValue,
      other: data.other,
    })
    isMultipleFields && onNext()
    refreshWidgetHeight?.()
  }

  return (
    <FieldWrapper
      {...props}
      className={cn({ [styles.wrapper]: !isMultipleFields })}
      handlerProps={{ disabled, visible: true, onNext }}
    >
      {choicesStyle === ChoiceStyle.TAG ? (
        <InlineSelect
          type={'checkbox'}
          options={choices}
          onChange={handleChange}
          choicesRandom={choicesRandom}
          checkedOptions={value?.value}
          choicesSize={choicesSize}
          rowChoiceCount={rowChoiceCount}
          ref={ref}
          min={minChoices}
          max={maxChoices}
        />
      ) : (
        <Select
          type="checkbox"
          options={choices}
          onChange={handleChange}
          choicesRandom={choicesRandom}
          checkedOptions={value?.value}
          min={minChoices}
          max={maxChoices}
        />
      )}
    </FieldWrapper>
  )
}

export default forwardRef(CheckboxSelectField)
